import type { ReactNode } from 'react';
import { DS2 } from '../../theme/designTokens';

interface Props {
  children:     ReactNode;
  loading?:     boolean;
  loadingLabel?: ReactNode;
  disabled?:    boolean;
  /** Figma height — 39 (363×52 ×0.75) for Login/Forgot Password forms, 43.5 for the wider success CTA. */
  height?:      number;
}

/**
 * DS2 Auth-family gold submit button — Figma Group 46 (363×52 ×0.75).
 * Extracted from the approved LoginScreen's "Log In" button.
 */
export function AuthSubmitButton({ children, loading, loadingLabel, disabled, height = 39 }: Props) {
  const isOff = loading || disabled;
  return (
    <button
      type="submit"
      disabled={isOff}
      style={{
        width:          '100%',
        height,
        boxSizing:      'border-box',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        borderRadius:   11.25,
        background:     DS2.gradient.gold,
        border:         '0.75px solid #C9A84C',
        boxShadow:      '0px 22.5px 60px -22.5px rgba(201, 168, 76, 0.45)',
        color:          '#FFFFFF',
        fontFamily:     DS2.font.body,
        fontWeight:     500,
        fontSize:       16.5,
        cursor:         isOff ? 'default' : 'pointer',
        opacity:        isOff ? 0.7 : 1,
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      {loading ? (loadingLabel ?? children) : children}
    </button>
  );
}
